import * as Sentry from '@sentry/browser';
import { getAppVersion } from '../utils/env/getAppVersion';

export const sentryClient = new Sentry.BrowserClient({
  dsn: 'https://5b134f4b82ff4429aec29eca1b229f87@sentry.wixpress.com/167',
  environment: process.env.NODE_ENV,
  release: `video-maker-home@${getAppVersion()}`,
});
